<template>
  <div class="rank_wrap" v-if="rank">

    <img class="title" src="https://vipcdn.mgtv.com/upload3/201810/20181025/zp2018/rank_title2.png" alt="">

    <div class="scroll_wrap">
      <div class="videos" :style="videos_style">
        <div class="video" v-for="item in rank" @click="toVideo(item)">
          <img :src="item.imgurl" alt="">
          <div>{{item.part_name}}</div>
          <div>{{readableNum(item.share_num)}}人已分享</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

  import click_handler from '../tools/mgtv/click'
  import {friendlyTime} from '../tools/time-format'
  import {openSchema} from '../tools/mgtv/link'
  import {readableNum} from '../tools/numFormat'
  export default {
    name: 'Rank',
    props: {},
    data() {
      return {}
    },
    computed: {
      user() {
        return window.$bus.user
      },
      rank() {
        return window.$bus.zp_rank
      },
      videos_style() {
        return {
          width: (2.2 * this.rank.length) + 'rem'
        }
      }
    },
    methods: {
      toVideo(item) {
        click_handler('点击排行榜', () => {
          openSchema(item.schema)
        }, {
          need_vip: false,
          need_act: false,
          need_login: false
        })
      },
      readableNum:readableNum
    },
    mounted() {

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

  @import "../share/mixins.styl"
  @import "../share/1px.styl"

  .rank_wrap
    position relative
    margin .3rem .2rem
    background #211435
    padding-top .2rem
    .title
      margin 0 auto
      display block
      width 3.2rem
      margin-bottom .3rem
    .scroll_wrap
      overflow-x scroll
      -webkit-overflow-scrolling touch
    .videos
      position relative
      max-width 1000%
      border 1px solid transparent
      .video
        display inline-block
        position relative
        width 1.93rem
        margin-right .2rem
        img
          width 100%
        div:nth-child(2)
          color white
          font-size .26rem
          text-align center
          width 100%
          ellipsis()
          padding-top .1rem
        div:nth-child(3)
          color #ff8141
          font-size .26rem
          text-align center
          width 100%
          padding-top .05rem
          ellipsis()


</style>



// WEBPACK FOOTER //
// src/components/Rank.vue